import './../../../scss/vendor/bootstrap.scss';
import './../../../scss/vendor/bootstrap-theme.scss';

import './../../../scss/app/splash-page/main.scss';

import Select from './modules/select';

const select = new Select();


// WEBPACK FOOTER //
// src/js/app/splash-page/main.js